import React from 'react'
import Typography from '@material-ui/core/Typography'
import LOG from '../logging/Logger'

export default () => {
  LOG.debug('Render: ErrorPage')

  return <Typography variant='h4'>Page not found</Typography>
}
